import {$host} from "../../../http";

const API_BASE = '/web/event_message';

export async function fetchTriggersApi() {
    try {
        const {data} = await $host.get(API_BASE);
        return data;
    } catch (error) {
        throw new Error('Ошибка при загрузке триггеров');
    }
}

export async function createTriggerApi(formData) {
    try {
        const {data} = await $host.post(API_BASE, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        throw new Error('Ошибка при создании триггера');
    }
}

export async function updateTriggerApi(id, formData) {
    try {
        const {data} = await $host.patch(`${API_BASE}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        throw new Error('Ошибка при обновлении триггера');
    }
}

export async function deleteTriggerApi(id) {
    try {
        const {data} = await $host.delete(`${API_BASE}/${id}`);
        return data;
    } catch (error) {
        throw new Error('Ошибка при удалении триггера');
    }
}

export async function switchTriggerApi(id, value) {
    try {
        const {data} = await $host.patch(`${API_BASE}/${id}/switch`, {value}, {
            headers: {'Content-Type': 'application/json'},
        });
        return data;
    } catch (error) {
        throw new Error('Ошибка при переключении триггера');
    }
}
